// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-container {
  max-width: 1440px;
  margin: 0 auto;
  padding: 20px;
  background-color: #f8f9ef;
  border-radius: 8px;
}

.stats {
  display: flex;
  gap: 20px;
  justify-content: space-between;
  padding-bottom: 50px;
}

.card {
  background-color: #fff;
  padding: 1.5rem;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
  flex: 1 1;
}

.card h2 {
  font-size: 1.2rem;
  color: #333;
}

.card p {
  font-size: 2rem;
  color: #27ae60;
}

.card-container {
  display: grid;
  justify-content: center;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  padding-bottom: 50px;
}

.card-container-2 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  justify-content: center;
}

.map-container {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  padding: 1.5rem;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* Chart Container */

.chart-container {
  width: auto;
  height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  padding: 1.5rem;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* Exploration Container */

.exploration-container {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  padding: 1.5rem;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* Dropdown Styles */

.dropdown-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #27ae60;
  font-size: 1.2rem;
  font-weight: bold;
  color: #fff;
  border-radius: 8px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  padding: 1rem;
  margin-bottom: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.dropdown-container {
  display: flex;
  width: 100%;
  gap: 1rem;
  margin: 8px 0;
}

.dropdown-item-left {
  flex: 1 1;
}

.dropdown-item-right {
  flex: 2 1;
}

.dropdown-item-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  border-radius: 8px;
  padding: 1.5rem;
  margin-bottom: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.dropdown-item-bar-pendente {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgb(165, 63, 63);
  color: #fff;
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.dropdown-item-bar-empty {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #a0a0a0;
  color: #fff;
  border-radius: 8px;
  padding: 1.5rem;
  margin-bottom: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.dropdown-item-bar-submetida {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgb(216, 162, 24);
  color: #fff;
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.dropdown-item-bar-concluida {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #27ae60;
  color: #fff;
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.dropdown-item-bar-btns {
  display: flex;
  gap: 0.5rem;
}

.btn-dash-edit,
.btn-dash-pdf,
.btn-dash-view {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 3rem;
  background-color: #fff;
  border: none;
  padding: 0.5rem 5rem;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1rem;
}

/* Detalhes de cultura concluída */

.concluida-details-card {
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 0.5rem;
  margin: 2rem 0;
  padding: 2rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.concluida-details-content {
  display: flex;
  gap: 3rem;
}

.concluida-details-content-left {
  flex: 2 1;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: repeat(4, 1fr);
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: #fff;
  padding: 1rem;
}

.concluida-details-content-label {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  min-height: 2rem;
  min-width: 2rem;
  margin: 0.5rem;
  color: #222;
  font-weight: normal;
}

.concluida-details-content-label.bold {
  font-weight: bold;
}

.concluida-details-content-right {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: #fff;
  padding: 1rem;
}

.concluida-details-content-right h3 {
  font-size: 4rem;
  color: #27ae60;
}

.concluida-details-content-right p {
  font-size: 1.2rem;
  line-height: 2rem;
}
`, "",{"version":3,"sources":["webpack://./src/css/sg-dashboard.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,qCAAqC;EACrC,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA,oBAAoB;;AAEpB;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA,0BAA0B;;AAE1B;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA,oBAAoB;;AAEpB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,WAAW;EACX,SAAS;EACT,aAAa;AACf;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,4BAA4B;EAC5B,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;EAC7B,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;;;EAGE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA,kCAAkC;;AAElC;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,cAAc;EACd,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,aAAa;EACb,qCAAqC;EACrC,kCAAkC;EAClC,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB","sourcesContent":[".dashboard-container {\n  max-width: 1440px;\n  margin: 0 auto;\n  padding: 20px;\n  background-color: #f8f9ef;\n  border-radius: 8px;\n}\n\n.stats {\n  display: flex;\n  gap: 20px;\n  justify-content: space-between;\n  padding-bottom: 50px;\n}\n\n.card {\n  background-color: #fff;\n  padding: 1.5rem;\n  border-radius: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  text-align: center;\n  flex: 1;\n}\n\n.card h2 {\n  font-size: 1.2rem;\n  color: #333;\n}\n\n.card p {\n  font-size: 2rem;\n  color: #27ae60;\n}\n\n.card-container {\n  display: grid;\n  justify-content: center;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 20px;\n  padding-bottom: 50px;\n}\n\n.card-container-2 {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 20px;\n  justify-content: center;\n}\n\n.map-container {\n  width: 100%;\n  height: auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #fff;\n  padding: 1.5rem;\n  border-radius: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n/* Chart Container */\n\n.chart-container {\n  width: auto;\n  height: 400px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #fff;\n  padding: 1.5rem;\n  border-radius: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n/* Exploration Container */\n\n.exploration-container {\n  width: 100%;\n  height: auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #fff;\n  padding: 1.5rem;\n  border-radius: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n/* Dropdown Styles */\n\n.dropdown-bar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: #27ae60;\n  font-size: 1.2rem;\n  font-weight: bold;\n  color: #fff;\n  border-radius: 8px;\n  cursor: pointer;\n  user-select: none;\n  padding: 1rem;\n  margin-bottom: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n}\n\n.dropdown-container {\n  display: flex;\n  width: 100%;\n  gap: 1rem;\n  margin: 8px 0;\n}\n\n.dropdown-item-left {\n  flex: 1;\n}\n\n.dropdown-item-right {\n  flex: 2;\n}\n\n.dropdown-item-bar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: #fff;\n  border-radius: 8px;\n  padding: 1.5rem;\n  margin-bottom: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n}\n\n.dropdown-item-bar-pendente {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: rgb(165, 63, 63);\n  color: #fff;\n  border-radius: 8px;\n  padding: 1rem;\n  margin-bottom: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n}\n\n.dropdown-item-bar-empty {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: #a0a0a0;\n  color: #fff;\n  border-radius: 8px;\n  padding: 1.5rem;\n  margin-bottom: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n}\n\n.dropdown-item-bar-submetida {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: rgb(216, 162, 24);\n  color: #fff;\n  border-radius: 8px;\n  padding: 1rem;\n  margin-bottom: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n}\n\n.dropdown-item-bar-concluida {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: #27ae60;\n  color: #fff;\n  border-radius: 8px;\n  padding: 1rem;\n  margin-bottom: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n}\n\n.dropdown-item-bar-btns {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.btn-dash-edit,\n.btn-dash-pdf,\n.btn-dash-view {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 3rem;\n  background-color: #fff;\n  border: none;\n  padding: 0.5rem 5rem;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 1rem;\n}\n\n/* Detalhes de cultura concluída */\n\n.concluida-details-card {\n  display: flex;\n  flex-direction: column;\n  background-color: #fff;\n  border-radius: 0.5rem;\n  margin: 2rem 0;\n  padding: 2rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n}\n\n.concluida-details-content {\n  display: flex;\n  gap: 3rem;\n}\n\n.concluida-details-content-left {\n  flex: 2;\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  grid-template-rows: repeat(4, 1fr);\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  background-color: #fff;\n  padding: 1rem;\n}\n\n.concluida-details-content-label {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 8px;\n  min-height: 2rem;\n  min-width: 2rem;\n  margin: 0.5rem;\n  color: #222;\n  font-weight: normal;\n}\n\n.concluida-details-content-label.bold {\n  font-weight: bold;\n}\n\n.concluida-details-content-right {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  background-color: #fff;\n  padding: 1rem;\n}\n\n.concluida-details-content-right h3 {\n  font-size: 4rem;\n  color: #27ae60;\n}\n\n.concluida-details-content-right p {\n  font-size: 1.2rem;\n  line-height: 2rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
